import React, { useState } from 'react';

const Solutions = () => {
const [showVideo, setShowVideo] = useState(false);
  return (
    <div className="relative bg-white">
      {/* Background Layer */}

      {/* Content */}
      <div className="relative z-10 px-4 md:px-20 pb-10 md:pt-5 pt-1">
        {/* Heading */}
        <div className="mt-2 md:mt-2 md:mb-5 mb-2">
          <h1 className="text-[12px] md:text-[36px] font-bold text-[#FDBD26] md:mb-3">
            Experience Farmnet App
          </h1>
          <h1 className="text-[12px] md:text-[40px] font-bold text-black">
          Contracts
          </h1>
        </div>

        {/* Records Section */}
        <div className="bg-[#2E453D] rounded-md w-full md:h-[630px] h-[175px] relative flex items-center justify-center p-2 md:p-0 mt-4">
          <div className="rounded-xl overflow-hidden relative w-full h-[300px] md:-mt-5 md:h-[700px] flex justify-center items-center cursor-pointer">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745110450/image_39_uz7bor.png"
              alt="Mobile"
              className="object-cover w-[20%] h-[50%] md:w-[22%] md:h-[83%] object-center"
            />
              <div
              className="absolute inset-0 flex justify-center items-center"
              onClick={() => setShowVideo(true)}
            >
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                alt="Play Icon"
                className="w-[50px] h-[50px] md:w-[110px] md:h-[110px] object-contain cursor-pointer"
              />
            </div>
          </div>
          <div className="absolute bottom-[10px] md:bottom-8 left-4 md:left-10 text-[#FDBD26]">
            <p className="text-[12px] md:text-[43px] font-bold text-[#FDBD26]">Contracts </p>
          </div>
          {/* Logo */}
          <div className="absolute left-4 md:left-6 top-0 md:top-4 w-[60px] md:w-[200px] h-[50px] md:h-[80px] z-10">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744195055/image_14_o9yorx.png"
              alt="Logo"
              className="w-full h-full object-contain"
            />
          </div>
          {/* See More Button */}
          <div className="absolute bottom-0 right-0 bg-[#152C24] z-20 rounded-tl-[50px] flex items-center justify-evenly md:px-4 px-1 w-[100px] h-[20px] md:w-[320px] md:h-[82px]">
            <a href="/experiencemain">
              <div className="flex items-center justify-between space-x-3 md:space-x-16 mt-1 md:mt-1 ml-2 md:ml-7">
                <p className="text-[8px] md:text-[23.5px] text-white font-bold">Read more</p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
                  alt="Expand"
                  className="w-[15px] md:w-[60px] h-[15px] md:h-[50px] object-contain"
                />
              </div>
            </a>
          </div>
        </div>
        <p className="md:text-[32px] text-[8px] font-normal md:mt-16 mt-2">
          <div className="md:mb-10 mb-3" style={{ lineHeight: '1.30' }}>
            The Farmnet Mobile App offers farmers a robust contract management solution that enhances market assurance and streamlines agricultural operations. By facilitating structured agreements between farmers and buyers, the app provides several key benefits:
          </div>
          <div className="md:mb-10 mb-5" style={{ lineHeight: '1.30' }}>
            <strong>Accessing Market Assurance Through Contract Management</strong>
          </div>
          <div className='h-5'></div>
        <div>
        <div className="" style={{ lineHeight: '1.30' }}>
            <strong>Guaranteed Markets and Price Stability:</strong> The app enables farmers to enter into contracts that ensure a steady market for their produce at predetermined prices. This arrangement shields farmers from market volatility and income fluctuations.
          </div>
          <div className="" style={{ lineHeight: '1.30' }}>
            <strong>Provision of Inputs and Technical Support:</strong> Through the app, buyers supply farmers with essential inputs such as seeds, fertilizers, and pesticides. Additionally, technical guidance on best farming practices is provided, leading to improved productivity and product quality.
          </div>
          <div className="" style={{ lineHeight: '1.30' }}>
            <strong>Financial Support and Risk Mitigation:</strong> The app's contract management feature offers financial assistance options and incorporates risk-sharing mechanisms. This support helps farmers manage unforeseen challenges like adverse weather conditions or pest infestations.
          </div>

        </div>
          <div className="md:mb-10 mb-3" style={{ lineHeight: '1.30' }}>
            <strong>Benefits of Using the Contract Management Solution</strong>
          </div>
          <div className='h-5'></div>
<div>

<div className="" style={{ lineHeight: '1.30' }}>
            1. <strong>Streamlined Contract Execution:</strong> The app digitizes the contract lifecycle, allowing farmers to create, track, and manage agreements electronically. This digital approach reduces administrative burdens and minimizes errors associated with manual processes.
          </div>
          <div className="" style={{ lineHeight: '1.30' }}>
            2. <strong>Automated Reminders and Notifications:</strong> Farmers receive timely alerts for critical contract milestones, such as delivery deadlines or payment schedules, ensuring adherence to agreement terms and fostering trust with buyers.
          </div>
          <div className="" style={{ lineHeight: '1.30' }}>
            3. <strong>Enhanced Compliance and Transparency:</strong> The app maintains a secure repository of contract documents, promoting transparency and simplifying compliance with legal and regulatory standards. This feature is crucial for resolving disputes and ensuring all parties fulfill their obligations.
          </div>
          <div className="" style={{ lineHeight: '1.30' }}>
            4. <strong>Improved Communication and Collaboration:</strong> Integrated communication tools within the app facilitate seamless interactions between farmers and buyers, enhancing collaboration and strengthening business relationships.
          </div>
          <div className="" style={{ lineHeight: '1.30' }}>
            5. <strong>Data-Driven Decision Making:</strong> Access to centralized contract data and performance metrics empowers farmers to make informed decisions, optimize operations, and identify opportunities for growth.
          </div>

</div>
          <div className='md:h-14 h-5'></div>

          <div className="md:mb-10 mb-3" style={{ lineHeight: '1.30' }}>
            The Farmnet Mobile App's contract management solution provides farmers with secure market access, financial stability, and operational efficiency, contributing to sustainable agricultural practices and improved livelihoods.
          </div>
        </p>

        <div className="md:h-20 h-5"></div>
      </div>
       {/* Video Modal */}
       {showVideo && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center">
          <div className="relative w-full h-full">
            <button
              onClick={() => setShowVideo(false)}
              className="absolute top-2 right-4 text-white text-4xl z-50"
            >
              &times;
            </button>
            <video
              src="https://res.cloudinary.com/dzngpgki4/video/upload/v1744223814/agxxfex5imknnkurmp0a.mp4"
              controls
              autoPlay
              className="w-full h-full md:p-20  p-4 object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Solutions;
